export default "__VITE_ASSET__bd7ab445__"